
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { useCosts } from "@/hooks/useCosts";

export function TableCostos() {
  const { costs, isLoading } = useCosts();

  if (isLoading) {
    return <div>Loading...</div>;
  }

  return (
    <Card className="col-span-6">
      <CardHeader>
        <div className="flex justify-between items-center">
          <CardTitle className="text-base font-medium">Desglose de Costos</CardTitle>
        </div>
      </CardHeader>
      <CardContent>
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>Servicio</TableHead>
              <TableHead>Fecha</TableHead>
              <TableHead className="text-right">Costo</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {costs && Array.isArray(costs) && costs.map((cost) => (
              <TableRow key={cost.id}>
                <TableCell>{cost.service_name}</TableCell>
                <TableCell>{new Date(cost.date).toLocaleDateString()}</TableCell>
                <TableCell className="text-right">${cost.amount.toFixed(2)}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </CardContent>
    </Card>
  );
}
